import { __rest } from "tslib";
import * as React from 'react';
const EmailFill = (_a) => {
    var { size } = _a, props = __rest(_a, ["size"]);
    return (React.createElement("svg", Object.assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { fillRule: "evenodd", d: "M10.997 13.862c.293.293.677.439 1.061.439.384 0 .768-.146 1.061-.439l7.816-7.8c.042.138.065.285.065.438v11c0 .827-.673 1.5-1.5 1.5h-15c-.827 0-1.5-.673-1.5-1.5v-11c0-.16.025-.315.072-.46l7.925 7.822zm-7.27-8.647A1.49 1.49 0 014.5 5h15c.29 0 .56.082.79.225l-7.878 7.93a.499.499 0 01-.708 0l-7.977-7.94z" })));
};
EmailFill.displayName = 'EmailFill';
export default EmailFill;
//# sourceMappingURL=EmailFill.js.map